// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y6-1";
export var printerIcon = "_y6-0";